import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      light: {
        primary: '#FA5E15',
        secondary: '#FFFFFF',
        graymain: '#CCCCCC',
        accent: '#66AFED',
        error: '#FF5252',
        warning: '#FFC107',
        info: '#2196F3',
        success: '#4CAF50',
      },
      dark: {
        primary: '#0CC413',
        graymain: '#272727',
        secondary: '#000000',
        accent: '#66AFED',
        error: '#FF5252',
        warning: '#FFC107',
        info: '#2196F3',
        success: '#4CAF50',
      },
    },
  },
});
